module.exports = __webpack_public_path__ + "static/media/faq.386d7c41.md";